import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/SurveyApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */
/* eslint-disable quote-props */

/*
 * GET
 */

/**
 * Retrieves a list of instances
 */
export const listInstances = () => {
  return instance.get( "ListInstances" );
};

/**
 * Retrieves a list of instances related to the user
 */
export const listUserInstances = () => {
  return instance.get( "listUserInstances" );
};

/*
 * Loads a specific instance
 */
export const loadInstance = id => {
  return instance.get( `LoadInstance?id=${id}` );
};

/*
 * Retrieves an Style instances questions and answers
 */
export const listQuestions = ( instanceId = null, responseId = null ) => {
  return instance.get( `ListQuestions?instanceId=${instanceId}&responseId=${responseId}` );
};

/*
 * Gets the survey's final report data
 */
export const getFinalReportData = instanceId => {
  return instance.get( `ListQuestions?instanceId=${instanceId}` );
};

/*
 * POST
 */

/*
 * Saves questions against a specific survey
 */
export const saveSurveyQuestions = ( { instanceId, questions } ) => {
  const payload = {
    instanceId,
    questions,
  };
  return instance.post( "SaveSurveyQuestions", payload );
};

/*
 * Saves a response to a survey question
 */
export const saveResponse = ( {
  responseId,
  instanceId,
  answerSystemCode,
  surveyQuestionId,
} ) => {
  const payload = {
    responseId,
    instanceId,
    answerSystemCode,
    surveyQuestionId,
  };
  return instance.post( "SaveResponse", payload );
};

/*
 * Saves a new or existing Style instance to the user's account
 */
export const saveInstance = ( {
  instanceId,
  surveyName,
  surveyType,
  organisationName,
  organisationLogo,
  closingDateTime,
  pathwayItemId,
} ) => {
  const payload = {
    instanceId,
    surveyName,
    surveyType,
    organisationName,
    organisationLogo,
    closingDateTime,
    pathwayItemId,
  };

  return instance.post( "SaveInstance", payload );
};

/*
 * Set survey response data complete
 */
export const setSurveyAsComplete = respondantId => {
  return instance.post( "SetSurveyAsComplete", JSON.stringify( `${respondantId}` ) );
};

/*
 * updates the survey expiry date
 */
export const updatesSurveyExpiryDate = ( { instanceId, expiryDate } ) => {
  const payload = {
    instanceId,
    date: expiryDate,
  };

  return instance.post( "UpdateSurveyClosingDate", payload );
};
